import { useMemo } from 'react';
import { EdgeProps } from 'reactflow';

import { TravellerJourneyDetails } from 'api/traveller-journeys/types';
import { TravellerJourneyAction } from 'api/types';
import { BaseBuilder } from 'ui/journey-builder/base-builder';

import { LoopEdge, TravellerEdge, TravellerExtraEdge, TravellerSucceedEdge } from './edge';
import { nodeTypes } from './node-types/';
import { StatusCard } from './status-card';
import { TravellerJourneyErrorBoundary } from './traveller-journey-error-boundary';

export const TravellerJourneyBuilder = ({
  actions,
  traveller,
  disableInitialFitView,
}: {
  actions: TravellerJourneyAction[];
  traveller: TravellerJourneyDetails;
  disableInitialFitView?: boolean;
}) => {
  const edgeTypes = useMemo(
    () => ({
      defaultEdge: (edgeProps: EdgeProps) => <TravellerEdge {...edgeProps} />,
      travellerExtraEdge: (edgeProps: EdgeProps) => <TravellerExtraEdge {...edgeProps} />,
      travellerSucceedEdge: (edgeProps: EdgeProps) => <TravellerSucceedEdge {...edgeProps} />,
      loopEdge: (edgeProps: EdgeProps) => <LoopEdge {...edgeProps} />,
      loopEdgeInProgress: (edgeProps: EdgeProps) => <LoopEdge {...edgeProps} isInProgress />,
    }),
    [],
  );
  return (
    <TravellerJourneyErrorBoundary>
      <StatusCard actions={actions} traveller={traveller} />
      <BaseBuilder
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        disableInitialFitView={disableInitialFitView}
      />
    </TravellerJourneyErrorBoundary>
  );
};
